import classNames from 'classnames'
import React from 'react'
import './index.css'
import Flex from 'components/Flex'
import FlexColumn from 'components/FlexColumn'
import TextSemiBold from 'components/TextSemiBold'
import Span from 'components/Span'
import Button from 'components/Button'
import logEventAnalyticsUtil from 'utils/analytics/log-event'
import updateSelectedSubscriptionSellingPlanIdVariantAction from 'modules/variant/redux/actions/update-selected-subscription-selling-plan-id'
import useDispatch from 'hooks/use-dispatch'
import useSelector from 'hooks/use-selector'
import getSelectedSubscriptionSellingPlanRecurrenceLabelByIdVariantSelector from 'modules/variant/redux/selectors/subscription-info/get-selected-selling-plan-recurrence-label-by-id'
import getSelectedSubscriptionSellingPlanIdVariantSelector from 'modules/variant/redux/selectors/get-selected-subscription-selling-plan-id'
import getSubscriptionSellingPlanIdVariantSelector from 'modules/variant/redux/selectors/get-subscription-selling-plan-id'
import getFirstSubscriptionSellingPlanByIdVariantSelector from 'modules/variant/redux/selectors/subscription-info/get-first-subscription-selling-plan-id'
import logUtil from 'utils/log'
import updateSubscriptionSellingPlanIdVariantAction from 'modules/variant/redux/actions/update-subscription-selling-plan-id'
import { SUBSCRIPTIONS_DEFAULT_DISCOUNT_PERCENTAGE } from 'modules/subscription/constants'
import DownChevronIcon from 'components/Icons/DownChevron'
import openRecurrenceSidebarSubscriptionAction from 'modules/subscription/redux/actions/open-recurrence-sidebar'
import getYOffsetDomUtil from 'utils/dom/get-y-offset'
import hasSubscriptionByVariantIdCartSelector from 'modules/cart/redux/selectors/has-subscription-by-variant-id'

const TITLE = `Subscribe & save ${SUBSCRIPTIONS_DEFAULT_DISCOUNT_PERCENTAGE}%`
const ANALYTICS_EVENT = {
  SHOW_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP: 'SHOW_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP',
  SELECT_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP: 'SELECT_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP',
  SELECT_SUBSCRIBE_AND_SAVE_RECURRENCE_IN_QUICK_SHOP: 'SELECT_SUBSCRIBE_AND_SAVE_RECURRENCE_IN_QUICK_SHOP'
}

/**
 * @param props
 * @param {ProductVariantCollection} props.productVariant
 * @param {number} props.variantId
 * @return {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarDeliverySubscribeAndSaveButton (props) {
  const {
    variantId
  } = props

  const dispatch = useDispatch()

  const recurrenceLabel = useSelector(
    getSelectedSubscriptionSellingPlanRecurrenceLabelByIdVariantSelector({
      variantId,
      isShort: true
    })
  )
  const selectedSubscriptionSellingPlanId = useSelector(
    getSelectedSubscriptionSellingPlanIdVariantSelector(variantId)
  )
  const subscriptionSellingPlanId = useSelector(
    getSubscriptionSellingPlanIdVariantSelector(variantId)
  )
  const firstSubscriptionSellingPlanId = useSelector(
    getFirstSubscriptionSellingPlanByIdVariantSelector(variantId)
  )

  const hasSubscriptionForThisVariantInCart = useSelector(
    hasSubscriptionByVariantIdCartSelector(variantId)
  )

  const debugProps = {
    props,
    variantId,
    recurrenceLabel,
    selectedSubscriptionSellingPlanId,
    subscriptionSellingPlanId,
    firstSubscriptionSellingPlanId,
    hasSubscriptionForThisVariantInCart
  }

  logUtil('QuickShopProductSidebarDeliverySubscribeAndSaveButton').debug('debugProps=', debugProps)

  const handleClick = (event) => {
    event.preventDefault()
    logEventAnalyticsUtil(ANALYTICS_EVENT.SELECT_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP)
    dispatch(
      updateSubscriptionSellingPlanIdVariantAction({
        variantId,
        value: (
          selectedSubscriptionSellingPlanId
        )
      })
    )
  }

  const handleClickIcon = (event) => {
    event.preventDefault()
    logEventAnalyticsUtil(ANALYTICS_EVENT.SELECT_SUBSCRIBE_AND_SAVE_RECURRENCE_IN_QUICK_SHOP)
    dispatch(
      openRecurrenceSidebarSubscriptionAction({
        variantId,
        // @see {SubscriptionRecurrenceModal#handleUnmount}
        top: getYOffsetDomUtil()
      })
    )
  }

  const updateSubscriptionSellingPlanId = (value) => {
    dispatch(
      updateSubscriptionSellingPlanIdVariantAction({
        variantId,
        value
      })
    )
  }

  const update = () => {
    dispatch(
      updateSelectedSubscriptionSellingPlanIdVariantAction({
        variantId,
        value: (
          firstSubscriptionSellingPlanId
        )
      })
    )

    if (!hasSubscriptionForThisVariantInCart) {
      return
    }

    updateSubscriptionSellingPlanId(firstSubscriptionSellingPlanId)
  }

  const handleUpdate = () => {
    update()
  }

  React.useEffect(() => {
    handleUpdate()
  }, [
    firstSubscriptionSellingPlanId
  ])

  const handleMount = () => {
    logEventAnalyticsUtil(ANALYTICS_EVENT.SHOW_SUBSCRIBE_AND_SAVE_IN_QUICK_SHOP)
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  return (
    <Button
      className={
        classNames({
          'quick-shop-product-sidebar-delivery-subscribe-and-save-button': true,
          'quick-shop-product-sidebar-delivery-subscribe-and-save-button_selected': !!subscriptionSellingPlanId
        })
      }
      onClick={handleClick}
    >
      <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect
          width='40'
          height='40'
          rx='6'
          fill='#F7F7F8'
        />
        <path
          d='M29.75 12V17C29.75 17.414 29.414 17.75 29 17.75H24C23.586 17.75 23.25 17.414 23.25 17C23.25 16.586 23.586 16.25 24 16.25H27.3301C25.9401 13.524 23.123 11.75 20 11.75C15.451 11.75 11.75 15.451 11.75 20C11.75 24.549 15.451 28.25 20 28.25C23.153 28.25 25.9839 26.494 27.3879 23.667C27.5719 23.297 28.021 23.1431 28.394 23.3291C28.764 23.5141 28.9159 23.963 28.7319 24.334C27.0729 27.675 23.727 29.751 20.001 29.751C14.625 29.751 10.251 25.377 10.251 20.001C10.251 14.625 14.625 10.251 20.001 10.251C23.398 10.251 26.497 12.0219 28.251 14.8149V12C28.251 11.586 28.587 11.25 29.001 11.25C29.415 11.25 29.75 11.586 29.75 12Z'
          fill='#191531'
        />
      </svg>
      <FlexColumn
        className='quick-shop-product-sidebar-delivery-subscribe-and-save-button-content'
      >
        <TextSemiBold
          className='quick-shop-product-sidebar-delivery-subscribe-and-save-button-content-title'
        >
          {TITLE}
        </TextSemiBold>
        <Flex
          className='quick-shop-product-sidebar-delivery-subscribe-and-save-button-content-price-and-recurrence'
        >
          {/* <Span */}
          {/*  className='quick-shop-product-sidebar-delivery-subscribe-and-save-button-content-price' */}
          {/* > */}
          {/*  $34 */}
          {/* </Span> */}
          {/* <BulletIcon /> */}
          <Span
            className='quick-shop-product-sidebar-delivery-subscribe-and-save-button-content-recurrence'
          >
            {recurrenceLabel}
          </Span>
        </Flex>
      </FlexColumn>
      <Button
        className='quick-shop-product-sidebar-delivery-subscribe-and-save-button-icon'
        onClick={handleClickIcon}
      >
        <DownChevronIcon />
      </Button>
    </Button>
  )
}
